import { useQuery } from '@tanstack/react-query';
import { apiRequest, HttpMethod } from '@api/common';
import { queryKeys } from '@api/queryClient';

// ============================================================================
// Types
// ============================================================================

export interface Terminal {
  id: string;
  name: string;
  streetAddress: string;
  postalCode: string;
  city: string;
}

// ============================================================================
// API Functions
// ============================================================================

const API_ENDPOINT = 'terminal';

const fetchTerminals = async (): Promise<Terminal[]> => {
  return apiRequest<void, Terminal[]>(HttpMethod.GET, API_ENDPOINT);
};

const fetchTerminal = async (id: string): Promise<Terminal> => {
  return apiRequest<void, Terminal>(HttpMethod.GET, `${API_ENDPOINT}/${id}`);
};

// ============================================================================
// Query Hooks
// ============================================================================

/**
 * Fetch all terminals
 */
export const useTerminalsQuery = () => {
  return useQuery({
    queryKey: queryKeys.terminals.all,
    queryFn: fetchTerminals,
  });
};

/**
 * Fetch a single terminal by ID
 */
export const useTerminalQuery = (id: string | undefined) => {
  return useQuery({
    queryKey: queryKeys.terminals.detail(id!),
    queryFn: () => fetchTerminal(id!),
    enabled: !!id,
  });
};
